import { render, staticRenderFns } from "./ReviewWorkspaceHost.vue?vue&type=template&id=4716a480&"
import script from "./ReviewWorkspaceHost.vue?vue&type=script&lang=js&"
export * from "./ReviewWorkspaceHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports